import './MenuButton.css'

import PropTypes from 'prop-types'
import styled from 'styled-components'

import { useMenuButtonContext } from './MenuButton'

const BareButton = styled.button`
  border: 0;
  background: var(--wg-background);
`

/**
 * A single card in the Workgrid Design System.
 */

const MenuItem = ({ children, className, onClick }: any) => {
  const { onHideMenu } = useMenuButtonContext()

  const onClickItem = (event: any) => {
    event.stopPropagation()
    event.preventDefault()
    onHideMenu()
    onClick(event)
  }

  return (
    <BareButton type={'button'} onClick={onClickItem} className={'floating-menu-item dropdown-item ' + className}>
      {children}
    </BareButton>
  )
}

MenuItem.defaultProps = {
  className: 'menu-item'
}

MenuItem.displayName = 'MenuItem'

MenuItem.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func
}
MenuItem.defaultProps = {
  onClick: () => {}
}

export default MenuItem
